// 文案相关配置

export default {
    // 加油折扣文案
    oilDiscount: '7折起',
    oilDiscountNum: 7,
    // 加油城市
    oilCity: '全国334城',
    // 视频会员文案
    videoDiscount: '5折起',
    videoDiscountNum: 5,
};
